import type { ChildDom, PropValueOrDerived } from "vanjs-core";
import { t } from "../locale";
import { div, option, select } from "./van-tags";

interface Params {
	disabled?: PropValueOrDerived;
	onchange?: (value: boolean) => void;
	value?: PropValueOrDerived;
}

export const onOffSelect = (args: Params): ChildDom => {
	const { onchange, ...rest } = args;
	return div(
		{ class: "select" },
		select(
			{
				onchange: (e: Event) => {
					const target = e.target as HTMLSelectElement;
					onchange?.(target.value === "on");
				},
				...rest,
			},
			option({ value: "off" }, () => t.off),
			option({ value: "on" }, () => t.on),
		),
	);
};
